import { _deserializable } from '../_deserializable';

export class ShipToRequest extends _deserializable {

  public customer: string;

}
